// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__Mru9Z","pageTitle":"App_pageTitle__Qy8t9"};